import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import { INavbarState } from '../reducers/navbar';

const styles = (theme: Theme) =>
	createStyles({
		logo: {
			color: '#ddd',
			fontFamily: '"Arial Black", Helvetica-bold',
			fontSize: '20px',
			fontStyle: 'italic',
			fontWeight: 'normal',
			marginRight: 20,
			width: 'auto',
		},
		root: {
			flexGrow: 1,
		},
		title: {
			flex: 1,
			[theme.breakpoints.down('sm')]: {
				fontSize: '1rem',
			},
		},
	});

interface IState {
	isShowMenuLogout?: boolean;
	isShowConfirmLogout?: boolean;
	menuLogoutAnchorEl?: HTMLElement;
}

/**
 * ナビゲーションバー
 */
class NavbarAdmin extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			isShowConfirmLogout: false,
			isShowMenuLogout: false,
		};
	}

	public render() {
		const { classes, isShowProgress } = this.props;

		return (
			<AppBar position="static">
				<Progress open={isShowProgress ? true : false} />
				<Toolbar>
					<Hidden smDown={true}>
						<Typography variant="h6" className={classes.logo}>
							Generalist/LM
						</Typography>
					</Hidden>
					<Typography
						variant="h6"
						color="inherit"
						noWrap={true}
						className={classes.title}
					>
						{this.props.title}
					</Typography>
				</Toolbar>
			</AppBar>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = () => ({});

export interface INavbarProps {
	title: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & INavbarProps & INavbarState;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(NavbarAdmin);

const Navbar = withStyles(styles)(Connected);
Navbar.displayName = 'Navbar';

export default Navbar;



// WEBPACK FOOTER //
// ./src/containers/NavbarAdmin.tsx